import React, { useRef, useEffect } from 'react';
import '../../../scss/components/_intersectionDetails.scss';

const Cycle = props => {
    return (
        <>
           <div className='bicycleMovlData' style={{position:'absolute',top:'0'}}>
            <img className='crosswalkTopArrow' src={require('../../../assets/images/crosswalkArrow.svg')} />
            <img className='crosswalkLeftArrow' src={require('../../../assets/images/crosswalkArrow.svg')} />
            <img className='crosswalkRightArrow' src={require('../../../assets/images/crosswalkArrow.svg')} />
            <img className='crosswalkBottomArrow' src={require('../../../assets/images/crosswalkArrow.svg')} />
            <span className='crosswalkNb'>{props.bicycleCrosswalkCountData.sbMiddle}</span>
            <span className='crosswalkSb'>{props.bicycleCrosswalkCountData.nbMiddle}</span>
            <span className='crosswalkEb'>{props.bicycleCrosswalkCountData.ebMiddle}</span>
            <span className='crosswalkWb'>{props.bicycleCrosswalkCountData.wbMiddle}</span>

            <span className='amNbLeft'>{props.bicycleCountData.sbLeft}</span>
            <span className='amSbLeft'>{props.bicycleCountData.nbLeft}</span>
            <span className='amEbLeft'>{props.bicycleCountData.wbLeft}</span>
            <span className='amWbLeft'>{props.bicycleCountData.ebLeft}</span>
            <span className='amNbRight'>{props.bicycleCountData.sbRight}</span>
            <span className='amSbRight'>{props.bicycleCountData.nbRight}</span>
            <span className='amEbRight'>{props.bicycleCountData.wbRight}</span>
            <span className='amWbRight'>{props.bicycleCountData.ebRight}</span>
            <span className='amNbMiddle'>{props.bicycleCountData.sbMiddle}</span>
            <span className='amSbMiddle'>{props.bicycleCountData.nbMiddle}</span>
            <span className='amEbMiddle'>{props.bicycleCountData.wbMiddle}</span>
            <span className='amWbMiddle'>{props.bicycleCountData.ebMiddle}</span>
          </div>
        </>
    )
}
export default Cycle;